export enum DateFormat {
    ISO8061,
    fileName
}
